export enum CallStateEnum {
    DEVICE_TEST = -1,
    NONE = 0,
    CHANNEL_JOINED = 2,
    CALL_STARTING = 3,
    CALL_STARTED = 4,
    CALL_ENDING = 5,
    CALL_ENDED = 6,
}
